export default __webpack_public_path__ + "static/screenshot-actions-3dbc45b79ba5a946324bad1782ce34a1.png";